const AnalyticsEventNames = {
  /* GENERAL */
  SWITCH_TO_OLD_VERSION: 'SWITCH_TO_OLD_VERSION',

  TRIAL_BANNER_CONTACT_SALES: 'TopBar_TrialBanner_ContactSales_Click',
  FOLLOW_UP_SEARCH_FROM_SIDE_BAR: 'SideBar_Profile_Click',

  PURCHASE_FLOW_INIT: 'PurchaseFlow_Init',
  PURCHASE_FLOW_BILLING_DETAILS_SUBMIT: 'PurchaseFlow_BillingDetails_Submit',
  PURCHASE_FLOW_PAYMENT_SUBMIT: 'PurchaseFlow_Payment_Submit',
  PURCHASE_FLOW_COMPLETED: 'PurchaseFlow_Completed',
  PURCHASE_FLOW_COMPLETED_DOWNLOAD_INVOICE: 'PurchaseFlow_Completed_DownloadInvoice_Click',
  PURCHASE_FLOW_COMPLETED_START_USING_SEARCH: 'PurhcaseFlow_Completed_StartUsing_SEARCH',
  PURCHASE_FLOW_COMPLETED_START_USING_INVESTIGATE: 'PurhcaseFlow_Completed_StartUsing_INVESTIGATE',
  PURCHASE_FLOW_COMPLETED_START_USING_VERIFY: 'PurhcaseFlow_Completed_StartUsing_VERIFY',
  PURCHASE_FLOW_COMPLETED_MANAGE_SUBSCRIPTIONS: 'PurchaseFlow_Completed_ManageSubscriptions_Click',

  CANCEL_REDUCE_SUBSCRIPTION_MANAGE_SUBSCRIPTIONS: 'CancelReduceSubscriptionModal_Submit_Click',
  CANCEL_SUBSCRIPTION_MANAGE_SUBSCRIPTIONS: 'CancelSubscriptionModal_Submit_Click',
  RENEWAL_MODAL_MANAGE_SUBSCRIPTIONS: 'RenewalModal_Submit_Click',
  REDUCE_MODAL_MANAGE_SUBSCRIPTIONS: 'ReduceModal_Submit_Click',
  CLICK_ON_HELP_LINK: 'Header_ClickedOnHelpLink',

  HISTORY_PAGE_CLICK_SEARCH_AGAIN: 'HistoryPage_ClickSearchAgain',
  CLOSE_PASSWORD_BANNER: 'Header_ClosePasswordBanner',
  CHANGE_PASSWORD_FROM_BANNER: 'Header_ChangePasswordFromBanner',

  SEARCH_INSIGHTS_DOCS_BANNER_CLICK: 'SearchInsightsDocsBannerClick',
  SEARCH_INSIGHTS_DOCS_BANNER_CLOSE: 'SearchInsightsDocsBannerClose',
};

export default AnalyticsEventNames;
